import { gql } from '@apollo/client'

export const uploadDesignToCloud = gql`
  mutation UploadDesignToCloud($design: CloudContentInput!, $parent: String) {
    uploadDesignToCloud(design: $design, parent: $parent) {
      _id
      name
      file {
        url
        path
        preview
        metadata
        dimensions {
          x
          y
        }
        type
        ext
        size
      }
      ref
      parent
      type
      createdAt
      updatedAt
    }
  }
`
